import ShopType from "@/enum/ShopType";
import { jushitaAxios, pddAxios, jdAxios, doudianAxios, aliyunAxios } from "./platformAxios";

export enum AxiosPlatformType {
    JST,
    PDD,
    JD,
    DOUDIAN,
    ALIYUN,
}

export function axiosGroupByShopType(shopType: ShopType) {
    switch (shopType) {
        case ShopType.TAOBAO:
        case ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER:
        case ShopType.ALI_C2M:
        case ShopType.TAOBAO_DISTRIBUTION:
            return AxiosPlatformType.JST;
        case ShopType.PINDUODUO:
        case ShopType.PDD_FDS:
        case ShopType.PDD_DROP_SHIPPING_SUPPLIER:
        case ShopType.PDD_FULFILLMENT:
        case ShopType.KTT:
            return AxiosPlatformType.PDD;
        case ShopType.ALIBABA:
        case ShopType.ALIBABA_SUPPLIER:
            return AxiosPlatformType.JST;
        case ShopType.JD:
        case ShopType.JD_PURCHASE:
        case ShopType.JD_DROP_SHIPPING_SUPPLIER:
            return AxiosPlatformType.JD;
        case ShopType.DOUDIAN:
        case ShopType.DOUDIAN_IOP:
        case ShopType.DOUDIAN_SUPPLIER:
        case ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER:
            return AxiosPlatformType.DOUDIAN;
        default:
            return AxiosPlatformType.ALIYUN;
    }
}

export function getAxiosGroupByAxiosPlatformType(type: AxiosPlatformType) {
    switch (type) {
        case AxiosPlatformType.JST:
            return jushitaAxios;
        case AxiosPlatformType.PDD:
            return pddAxios;
        case AxiosPlatformType.JD:
            return jdAxios;
        case AxiosPlatformType.DOUDIAN:
            return doudianAxios;
        case AxiosPlatformType.ALIYUN:
            return aliyunAxios;
        default:
            return aliyunAxios;
    }
}

export function getAxiosByShopType(shopType: ShopType) {
    switch (shopType) {
        case ShopType.TAOBAO:
        case ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER:
        case ShopType.ALI_C2M:
        case ShopType.TAOBAO_DISTRIBUTION:
            return jushitaAxios;
        case ShopType.PINDUODUO:
        case ShopType.PDD_FDS:
        case ShopType.PDD_FULFILLMENT:
        case ShopType.PDD_DROP_SHIPPING_SUPPLIER:
        case ShopType.KTT:
            return pddAxios;
        case ShopType.ALIBABA:
        case ShopType.ALIBABA_SUPPLIER:
            return jushitaAxios;
        case ShopType.JD:
        case ShopType.JD_PURCHASE:
        case ShopType.JD_DROP_SHIPPING_SUPPLIER:
            return jdAxios;
        case ShopType.DOUDIAN:
        case ShopType.DOUDIAN_IOP:
        case ShopType.DOUDIAN_SUPPLIER:
        case ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER:
            return doudianAxios;
        default:
            return aliyunAxios;
    }
}
